// extracted by mini-css-extract-plugin
module.exports = {"SideDrawer":"SideDrawer_SideDrawer__qEsJ0","Open":"SideDrawer_Open__sdCrZ","Close":"SideDrawer_Close__2XBNq","Logo":"SideDrawer_Logo__Xs8lt"};